// 本文件包含一些http请求header设置方法

/**
 * 生成X-Context，用于在请求api时加在http请求header中带给后台，供后台统计用
 * 包含参数：ns-域空间ID，c-项目ID, org-公司ID，os-系统类型(0-未知,1-IOS,2-Android,3-windowsPhone,4-火狐,5-Blackberry,
 * 6-IOSWeiXin,7-AndriodWeiXin,8-公众号,9-支付宝,10-小程序,11-PC工作台,12-PC服务广场, 15-电商后台),参数间使用一个英文空格隔开，如user-agent
 * 例子：X-Context: ns/11 c/240000 org/102406 os/1
 * @param {object} params 需要写进X-Context的字段
 */
function genXContext (params) {
	const { namespaceId: ns, organizationId: org, communityId: c } = window.$$context || {};
	const fieldsObj = { ns, c, org, os: 15, ...params };
	let XContextArr = [];
	Object.entries(fieldsObj).forEach(kv => {
		if (kv[0] && kv[1]) {
			XContextArr.push(`${kv[0]}/${kv[1]}`);
		}
	});
	return XContextArr.join(' ');
}

const headersMethod = {
	genXContext,
};

export {
	headersMethod
};
